/* @flow */

export default {
  CONTENT_SOURCE_FORM: {
    VIEW: 'developer_console.content_source_form.view',
    SUBMIT: 'developer_console.content_source_form.submit.click',
  },
  OAUTH_FORM: {
    VIEW: 'developer_console.oauth_form.view',
    SUBMIT: 'developer_console.oauth_form.submit.click',
  },
};
